module.exports = {
	"Заполните название вашей компании": "Заповніть назву вашої компанії",
	"Заполните ваше имя и фамилию": "Заповніть ваше ім’я та прізвище",
	"Телефон должен начинаться с \"+\" и кода страны": "Телефон має починатися з «+» та коду країни",
	"Телефон должен быть в международном формате и содержать 12 цифр": "Напишіть номер в міжнародному форматі, щоб він містив 12 цифр",
	"Неправильный имейл": "Помилкова ел. пошта",
	"Пароль должен сожержать не меньше 8 символов": "Пароль повинен містити не менше 8 символів",
	"Текст об интеграции должен быть не меньше двух предложений (100 символов)": "Текст про інтеграцію повинен бути не менше двох речень (100 символів)",
	"Неправильный номер телефона. Попробуйте ввести номер в международном формате.": "Помилковий номер телефону. Спробуйте ввести номер в міжнародному форматі."
};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/ua/site.json
// module id = 267
// module chunks = 1